/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-p1.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-p2.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-p3.png",

    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b1.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b2.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b3.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b4.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b5.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b6.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b7.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b8.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-b9.png",

    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-a1.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-a2.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-a3.png",
    "https://cdn.shopify.com/s/files/1/0823/0912/0274/files/202508082-a4.png",
  ];
  var thumbsp1 = new Swiper("#thumbs-p1", {
    direction: "vertical",
    spaceBetween: 10,
    slidesPerView: 3,
    watchSlidesVisibility: true, //防止不可点击
  });

  let swiper = new Swiper("#swiper-p1", {
    speed: 1,
    on: {
      slideChange: function (e) {
        $(".product-part2 #sp-color .sp-option")
          .eq(e.activeIndex)
          .addClass("active")
          .siblings()
          .removeClass("active");
        changePrice($('.product-part2'));
      },
    },
    thumbs: {
      swiper: thumbsp1,
    },
  });

  var thumbsp2 = new Swiper("#thumbs-p2", {
    direction: "vertical",
    spaceBetween: 10,
    slidesPerView: 3,

    watchSlidesVisibility: true, //防止不可点击
  });
  let swiper2 = new Swiper("#swiper-p2", {
    on: {
      slideChange: function (e) {
        $(".sp-mask #sp-color .sp-option")
          .eq(e.activeIndex)
          .addClass("active")
          .siblings()
          .removeClass("active");
        changePrice($('.sp-mask .product-part'));
      },
    },
    thumbs: {
      swiper: thumbsp2,
    },
    speed: 1,
    slidesPerView: "auto",
  });

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    speed: 6000,
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 29.99;
  let sp_price2 = 53.98;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  
  let prods = window.product
  function getCur(current) {
    let color = current.find('#sp-color div.active').attr('data-val')
    let number = current.find('#sp-num div.active').attr('data-val')

    let checkDom = current.find(".sp-check div")
    let haveAdd = checkDom.hasClass("active")
    let option3 = haveAdd ? checkDom.attr('data-val2') : checkDom.attr('data-val1')
    return prods.filter(item => item.option1 == color && item.option2 == number && item.option3 == option3)[0]
  }
  function changePrice(current) {
    let num = current.find('#calcNumber').val()
    let price = ((getCur(current).price * num) / 100).toFixed(2)
    let compare = ((getCur(current).compare_at_price * num) / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    current.find('#sp_price1').html(price)
    current.find('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur(current).price / getCur(current).compare_at_price) * 100)
    current.find('.sp-row p span').html(off_font)
  }
  $('.sp-btn-style').on('click', function () {
    let id = getCur($(this).closest('.product-part')).id
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + id + ':' + num
  })

  $(".product-part2 .sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice($(this).closest('.product-part'));
  });
  $(".product-part2 .sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice($(this).closest('.product-part'));
  });

  $(".sp-mask .sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice($(this).closest('.product-part'));
  });
  $(".sp-mask .sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice($(this).closest('.product-part'));
  });
  $(".sp-btn-pop").click(function () {
    $(".sp-mask").css("display", "flex");
    $(".sp-mask .sp-pop2").hide();
    $(".sp-pop").show();
  });
  // 展示尺码弹窗
  $(".sp-size-btn").click(function () {
    $(".sp-mask").css("display", "flex");
    $(".sp-mask .sp-pop").hide();
    $(".sp-mask .sp-pop2").show();
  });

  // 关闭弹窗按钮

  $(".sp-mask").click(function (e) {
    if ($(e.target).closest(".sp-mask .sp-pop ").length > 0) {
    } else {
      $(".sp-mask").hide();
      $(".sp-mask .sp-pop2").hide();
      $(".sp-mask .sp-pop").hide();
    }
  });

  $(".sp-close-btn").click(function () {
    $(".sp-mask").hide();
    $(".sp-mask .sp-pop2").hide();
    $(".sp-mask .sp-pop").hide();
  });

  $(function () {
    $(".product-part2 .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      let colorOptions = $(
        ".product-part2 #sp-color .sp-option.active"
      ).index();

      swiper.slideTo(colorOptions);
      changePrice($(this).closest('.product-part'));
    });
    $(".sp-mask .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      let colorOptions = $(".sp-mask #sp-color .sp-option.active").index();

      swiper2.slideTo(colorOptions);
      changePrice($(this).closest('.product-part'));
    });
    
    
    $(".product-part .sp-check div").click(function () {
      $(this).toggleClass("active");
      
      if ($(this).hasClass("active")) {
        $(".product-part .sp-unselected").hide();
        $(".product-part .sp-selected").show();
      } else {
        $(".product-part .sp-unselected").show();
        $(".product-part .sp-selected").hide();
      }

      let productPart = $(this).closest('.product-part')
      let addOptions = productPart.find(".sp-check div").hasClass("active")
      
      if (addOptions) {
        productPart.find(`.swiper-no-swiping .swiper-slide :nth-child(1)`).hide()
        productPart.find(`.swiper-no-swiping .swiper-slide :nth-child(2)`).show()
      } else {
        productPart.find(`.swiper-no-swiping .swiper-slide :nth-child(1)`).show()
        productPart.find(`.swiper-no-swiping .swiper-slide :nth-child(2)`).hide()
      }
      changePrice(productPart)
    });

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });
    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let spNum = $(".product-part #calcNumber")[0].value;
      initNum += Number(spNum);
      
      let data = {
        id: getCur($(this).closest('.product-part')).id,
        quantity: spNum,
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $("#cardNum").removeClass("sp-gray");
          })
        },
        dataType: 'json',
      })
      // $("#calcNumber").val(1);
      // $("#cardNum").html(initNum);
      // $("#cardNum").removeClass("sp-gray");
      // handleAddToCart(initNum);

      // var img = $(".product-part .p-img");
      var img = $(".product-part .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top: finish[0].offsetTop + finish.height() / 2,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });

  // const tabs = $(".product-part2 .sp-tab");
  // const tabs2 = $(".sp-mask .sp-tab");

  // let currentIndex = 0; // 当前展示的tab索引
  // let currentIndex2 = 0; // 当前展示的tab索引

  // function nextTabFunc() {
  //   const currentTab = tabs[currentIndex];
  //   // 当前tab开始动画
  //   currentTab.classList.add("sp-tab-ani");

  //   let nextIndex = (currentIndex + 1) % tabs.length;
  //   const nextTab = tabs[nextIndex];

  //   setTimeout(() => {
  //     currentTab.classList.remove("sp-tab-ani");
  //   }, 2500);

  //   currentIndex = (currentIndex + 1) % tabs.length;
  //   setTimeout(nextTabFunc, 1500);
  // }

  // nextTabFunc();

  // function nextTabFunc2() {
  //   const currentTab = tabs2[currentIndex2];
  //   // 当前tab开始动画
  //   currentTab.classList.add("sp-tab-ani");

  //   let nextIndex = (currentIndex2 + 1) % tabs2.length;
  //   const nextTab = tabs2[nextIndex];

  //   setTimeout(() => {
  //     currentTab.classList.remove("sp-tab-ani");
  //   }, 2500);

  //   currentIndex2 = (currentIndex2 + 1) % tabs2.length;
  //   setTimeout(nextTabFunc2, 1500);
  // }

  // nextTabFunc2();

  // 开始动画循环
  // setTimeout(nextTab, 1500); // 可以根据需要设置初始延迟

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
});
